module.exports = __webpack_public_path__ + "img/do_not_print.a8b51e1e.webp";